import React from 'react';

const SchoolSelector = ({ onSelect }) => {
  const schools = [
    { id: 'EPF', name: 'E.P. Física 2026-2' },
    { id: 'EPM', name: 'E.P. Matemátic 2026-2' },
    { id: 'EPA', name: 'E.P. Administracion' },
    { id: 'EPC', name: 'E.P. Contabilidad' },
    { id: 'EPE', name: 'E.P. Economía' },
    { id: 'EPIEL', name: 'E.P. Ing. Eléctrica' },
    { id: 'EPII', name: 'E.P. Ing. Industrial' },
    { id: 'EPIS', name: 'E.P. Ing. Sistemas' },
    { id: 'EPIQ', name: 'E.P. Ing. Química' },
    { id: 'EPIAM', name: 'E.P. Ing. Ambiental' },
    { id: 'EPIME', name: 'E.P. Ing. Mecánica' },
    { id: 'EPIEN', name: 'E.P. Ing. Energía' },
    { id: 'EPEF', name: 'E.P. Educación Física' }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {schools.map(school => (
        <button key={school.id} onClick={() => onSelect(school.id)}
                className="p-4 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 hover:border-blue-500 transition-all hover:shadow-md font-semibold text-left">
          {school.name}
        </button>
      ))}
    </div>
  );
};

export default SchoolSelector;
